import { AdminApp } from "./AdminApp.js";
import { App } from "./App.js";
import { useAppMode } from "./app-mode.js";

/** Matrix desk vs Mairko firm admin — same Clerk session. */
export function ModeRoot() {
	const { mode } = useAppMode();
	if (mode === "admin") return <AdminApp />;
	return <App />;
}
